import styled, {css} from "styled-components"
import {Modal} from "react-bootstrap"

export const LoginMobileBrandImg = styled.img`
  ${({theme}) => css`
    width: auto;
    height: ${theme.spacing.three};
    display: block;
    flex: none;
  `}
`

export const NavigationMenuModal = styled(Modal)`
  .modal-content {
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    border-radius: 0;
  }

  .modal-dialog {
    margin: 0;
    width: 70%;
    border-radius: 0;
  }
`

export const StyledNavigationMenuContainer = styled.div`
  margin-right: ${({theme}) => theme.spacing.oneAndHalf};
  margin-left: ${({theme}) => theme.spacing.one}
`
